export enum DemoOrganisationType {
  AGENCY = 'AGENCY',
  HOSPITAL = 'HOSPITAL',
  PSYCHIATRY = 'PSYCHIATRY',
  LONGTERM_CARE = 'LONGTERM_CARE',
  SPITEX = 'SPITEX',
}
